import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";
import "cleave.js/dist/addons/cleave-phone.fr";

import * as commonFunc from 'scripts/common';

import {
    Input,
    Label, FormFeedback, Col
} from "reactstrap";


export default function CheckboxFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue, errors } = formManager;

    const checkRef = React.useRef();

    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        //var val = bindPropResult ? getValues(bindPropResult) : "";
        var value = data.defaultValue;
        //PATCH : value AKeyItem
        if (value?.startsWith && value.startsWith("{") && value.indexOf("tag") >= 0) {
            var keyItem = JSON.parse(value);
            value = keyItem.value;
            data.srcKeyItem = true;
        }
        var val = formatValue(value, false, true);
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: val }).then(actionResponse => {
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
        if ((!data.children || data.children.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    function formatValue(value, forceSet, noSet) {
        var formatValue = value;
        if (data.format) {
            data.rawValue = value;

            if (data.format === "true") {
                formatValue = (value && value !== "false");
            }
            else {
                if (data.subType === "integer" || data.subType === "float") formatValue = value ? data.format : 0;
                else formatValue = value ? data.format : "";
            }
            if (!noSet) setValue(bindPropResult, formatValue);
        }
        else if (forceSet) {
            setValue(bindPropResult, value);
        }
        return formatValue;
    }

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.isDisabled = () => { return ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)); };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.getValue = () => { return getValues(bindPropResult) };
    data.functionManager.setValue = (value, withRerender, src) => {
        return new Promise((resolve, reject) => {
            //setValue(bindPropResult, value);
            formatValue(value, true);
            if (withRerender) setShouldRender(!shouldRender);

            resolve({ isSuccess: true, result: value });
        });
    };
    data.functionManager.performClick = () => { checkRef.current.click(); };
    data.functionManager.triggerChange = (alternativeValue) => {
        return new Promise((resolve, reject) => {
            onChange();

            resolve({ isSuccess: true, result: null });
        });
    };


    var value = data.defaultValue;
    //PATCH : value AKeyItem
    if (value?.startsWith && value.startsWith("{") && value.indexOf("tag") >= 0) {
        var keyItem = JSON.parse(value);
        value = keyItem.value;
        data.srcKeyItem = true;
    }

    const { ref: refElem, ...restElem } = register(bindPropResult, {
        value: formatValue(value, false, true),
        valueAsNumber: (data.subType === "integer" || data.subType === "float"),
        setValueAs: (v) => {//PATCH 09/25
            if (data.srcKeyItem) {
                return `{"id":0,"tag":"${data.title}","value":"${v}"}`;
            }
            else {
                return v;
            }
        },
        onChange: (e) => {
            onChange();
        }
    });

    var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));

    function onChange() {
        var val = bindPropResult ? getValues(bindPropResult) : "";
        formatValue(val);

        if (data.onActionEvents && data.onActionEvents["onChange"]) {
            data.onActionEvents["onChange"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: val }).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
        if (data.onActionEvents && data.onActionEvents["onClick"]) {
            data.onActionEvents["onClick"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, { value: val }).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
    }

    function renderInput(widthClass) {
        //TODO : formattage chargement valeurs

        //INFO : Désactivation defaultChecked car rentrais en confusion avec le register ci-dessus
        // defaultChecked={formatValue(data.defaultValue, false, true)}
        return <div className={`d-inline-block ${widthClass}`} style={{ position: "relative", top: "-12px" }}>
            <Input ref={checkRef} type="checkbox" id={"input" + bindPropResult} placeholder={altT(data.placeHolder)} readOnly={data.readOnly} disabled={disabled}
                innerRef={refElem} {...restElem} invalid={commonFunc.getValue(errors, bindPropResult) ? true : false} />
            <span className={`form-check-sign`} />
        </div>;
    }

    function renderTitle(contentInput, titleClass, titleStyle) {
        var design = data.customDesign ? data.customDesign.designTitle : null;
        if (!design) design = {}
        var position = design.position;
        if (!position) position = "right";

        var titleContainer = <><div className="d-inline-block ">{altT(data.title)}</div>{data.children ? data.children.map((child) => modelFctManager.componentTyped(child, parentProps)) : ""}</>;



        //TODO : w-100 à voir avec les children... + /!\ le click s'effectue sur tout le label...
        return <Label check for={"input" + bindPropResult} className={`d-inline-block px-0 w-100 ${(!commonFunc.isBlank(data.title) && data.required) ? "mandatory" : ""}`} style={{minWidth:"16px"}}>
            {(position === "top" || position === "left") ? <div className={`d-inline-block me-2 ${titleClass}`} style={titleStyle}>{titleContainer}</div> : ""}
            {contentInput}
            {(position === "bottom" || position === "right") ? <div className={`d-inline-block ms-${commonFunc.isBlank(data.title) ? 2 : 4} ${titleClass}`} style={titleStyle}>{titleContainer}</div> : ""}
            <FormFeedback className={`text-start ${commonFunc.getValue(errors, bindPropResult) ? "d-block" : ""}`}>{commonFunc.getValue(errors, bindPropResult) ? commonFunc.getValue(errors, bindPropResult).message : t("gal_reqFields")}</FormFeedback>
        </Label>;
    }

    var frameClass = "mb-3";
    var frameStyle = {};
    var containerClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "form-group m-0 ";

    var widthClass = "";
    var titleClass = "px-0 ";
    var titleStyle = {};

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_checkbox");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass += modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }

        if (design.margin) {
            frameStyle.margin = design.margin;
            frameClass = frameClass.replace("mb-3", "");
        }
        if (design.marginStart) frameStyle.marginLeft = design.marginStart;
        if (design.marginTop) frameStyle.marginTop = design.marginTop;
        if (design.marginEnd) frameStyle.marginRight = design.marginEnd;
        if (design.marginBottom) {
            frameStyle.marginBottom = design.marginBottom;
            frameClass = frameClass.replace("mb-3", "");
        }
    }
    if (data.customDesign?.designInput) {
        if (data.customDesign.designInput.boxSize) {
            //widthClass += " w-" + parseInt(parseFloat(data.customDesign.designInput.boxSize) * 100);
            widthClass += modelFctManager.convertWidthToGrid(parseFloat(data.customDesign.designInput.boxSize) * 100);
        }
    }
    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_checkboxTitle", true);
    if (designTitle) {
        if (designTitle.alignment) {
            var split = designTitle.alignment.split("|");
            split.forEach((part) => {
                titleClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleClass = titleClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
        if (designTitle.boxSize) {
            //titleClass += " w-" + parseInt(parseFloat(designTitle.boxSize) * 100);
            titleClass += modelFctManager.convertWidthToGrid(parseFloat(designTitle.boxSize) * 100).replace("col-12", "").replace("md-", "");
            titleClass = titleClass.replace("px-0", "ps-3 px-md-0").replace("text-end", "text-md-end");
        }

        Object.assign(titleStyle, modelFctManager.managePadding(designTitle, titleClass));

        if (designTitle.fontColor) titleStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleStyle.fontStyle = "italic";
        }
    }

    if (!commonFunc.isBlank(widthClass) || titleClass !== "px-0 ") containerClass += " row m-0 row-cols-lg-auto2 align-items-center";


    var baseForm = <div className={`form-check form-check-inline fcheck-sm w-100 ${containerClass} ${formClass}`}>
        {renderTitle(renderInput(widthClass), titleClass, titleStyle)}
    </div>;


    //console.debug("render input");

    return <Col data-name="CheckboxFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}